import React from "react";
import SocialIcons from "./socialIcons";

import MeduimCard from "./MeduimCard";
import { useState } from "react";
//cake images
// import cake1 from "../images/cake1.jpg";
// import cake2 from "../images/cake2.jpg";
import cook from "../images/cook1.png";
import logo from "../images/logo.jpeg";
// import birthday from "../images/birthday.jpeg";
import cake4 from "../images/cake4.jpeg";
import cake5 from "../images/cake3.jpeg";
import cake6 from "../images/cake6.jpeg";
// import cake7 from "../images/cake7.jpeg";
import croissants from "../images/croissants.jpg";
import tresle from "../images/tresle.jpg";
import chocolatechip from "../images/chocolatechip.jpeg";
import cupcake2 from "../images/cupcake2.jpeg";
import female3 from "../images/female3.jpg";
import ediblephoto from "../images/ediblephoto.jpeg";
import doughnut from "../images/largefilleddoughnut.jpeg";
import wedding from "../images/wedding.jpg";
// import male from "../images/male.webp";
import male2 from "../images/male2.jpg";
import female from "../images/female.jpg";
import female2 from "../images/femal2.png";

// import avatar from "../images/avatar.jpg";
//forms
import CakeForm from "./forms/CakeForm";
import CupCakeForm from "./forms/CupCakeForm";
import Doughnut from "./forms/Doughnut";
import Testimonials from "./Testimonials";
//

const Homepage = () => {
  const [caketype, setCaketype] = useState({
    type: "",
  });

  //render form
  const formRender = () => {
    if (caketype.type === "cake") {
      return <CakeForm />;
    } else if (caketype.type === "cupcake") {
      return <CupCakeForm />;
    } else if (caketype.type === "doughnut") {
      return <Doughnut />;
    } else {
      return (
        <div className="no-order">
          <h3 className="sub-body-text">Place Order Here</h3>
          <img className="cook-img" src={cook} alt="cook-img" />
        </div>
      );
    }
  };
  const handleChange = (e) => {
    setCaketype({ type: e.target.value });
  };

  return (
    <div>
      <div className="top-body">
        <div className="top-body-text">
          Rossey Patisserie is a cake bakery in Ghana. All items are by special
          order and can be tailored to fit the client’s needs.
          <br />
          Our Mission is to provide a delicious cake & pastry experience that
          will have people dreaming about their next desert – big or small.
        </div>
        <img className="h-image" src={logo} alt="" />
        <SocialIcons />
      </div>
      <div className="middle-body">
        <div className="form-background">
          <h1 className="sub-body-text">What would you like to order ?</h1>
          <div>
            <h1>
              For special orders such as <br />
              <span style={{ fontWeight: "bold" }}>
                Wedding Cakes, Edible Photo Cakes and others,
              </span>
              <br />
              please contact us directly...
            </h1>
          </div>
          <form action="" className="main" onChange={handleChange}>
            <select className="main-select-box" name="typeofcake" id="">
              <option className="choose" value="">
                {" "}
                --Order--
              </option>
              <option value="cake">Cake</option>
              <option value="cupcake">Cup Cake</option>
              <option value="doughnut">Doughnut</option>
            </select>
          </form>
          {formRender()}
        </div>
      </div>
      <div className="works">
        <h2 className="sub-body-text">What We Love to Make</h2>
        <div className="section">
          <MeduimCard img={cake5} title="Birthday Cakes" />
          <MeduimCard img={wedding} title="Wedding Cakes" />
          <MeduimCard img={cake4} title="Cookies & Cream" />
          <MeduimCard img={cake6} title="Double Chocolate" />
          <MeduimCard img={tresle} title="Tres Leches" />
          <MeduimCard img={chocolatechip} title="Cookies" />
          <MeduimCard img={cupcake2} title="Cup Cakes" />
          <MeduimCard img={doughnut} title="Doughnuts" />
          <MeduimCard img={ediblephoto} title="Edible Photo Cakes" />
          <MeduimCard img={croissants} title="Croissant" />
        </div>
      </div>
      <div className="testimonials">
        <h3 className="t-title">What Our Clients Are Saying About Us</h3>
        <div className="t-main">
          <Testimonials
            image={female}
            name="Vanessa"
            text="Great cakes at affordable price"
          />
          <Testimonials
            image={male2}
            name="Nana Agyemang"
            text="I made an order with them and the delivery was timely, I was impressed."
          />
          <Testimonials
            image={female2}
            name="Abigail"
            text="Your croissants are soft and fluffy, literally the best i've ever had in ghana"
          />
          <Testimonials
            image={female3}
            name="Adepa Serwaa"
            text="I'm addicted to your doughnuts, I have them almost everyday"
          />
        </div>
      </div>
    </div>
  );
};

export default Homepage;
